export type DteStatusTone = 'warning' | 'info' | 'success' | 'error' | 'neutral';

export interface DteStatusPresentation {
  label: string;
  tone: DteStatusTone;
  className: string;
}

const presentations: Record<string, Omit<DteStatusPresentation, 'className'>> = {
  DTE_PENDING: {
    label: 'Emitido en contingencia / pendiente de envío',
    tone: 'warning',
  },
  DTE_SENT: {
    label: 'Enviado en lote / esperando respuesta',
    tone: 'info',
  },
  PROCESADO: {
    label: 'Procesado por Hacienda',
    tone: 'success',
  },
  DTE_PROCESSED: {
    label: 'Procesado por Hacienda',
    tone: 'success',
  },
  RECHAZADO: {
    label: 'Rechazado por Hacienda',
    tone: 'error',
  },
  DTE_REJECTED: {
    label: 'Rechazado por Hacienda',
    tone: 'error',
  },
};

const toneClasses: Record<DteStatusTone, string> = {
  warning: 'border-warning/30 bg-warning/10 text-warning',
  info: 'border-primary/30 bg-primary/10 text-primary',
  success: 'border-success/30 bg-success/10 text-success',
  error: 'border-danger/30 bg-danger/10 text-danger',
  neutral: 'border-stroke bg-gray-2 text-body dark:border-strokedark dark:bg-meta-4',
};

export const getDteStatusPresentation = (status?: string | null): DteStatusPresentation => {
  const normalized = status?.trim().toUpperCase() || '';
  const presentation = presentations[normalized] ?? {
    label: status?.trim() || 'Sin estado DTE',
    tone: 'neutral' as const,
  };

  return {
    ...presentation,
    className: toneClasses[presentation.tone],
  };
};
